import { DeleteFilled, EditFilled } from "@ant-design/icons/lib/icons";
import { Badge, Button, message, Popconfirm, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteDataJacket, getDataJacket } from "../../../config/Redux/action";

const DashboardJacket = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [jackets, setJackets] = useState([]);
  const loading = useSelector((state) => state.product.isLoading);

  useEffect(() => {
    const getData = async () => {
      const res = await dispatch(getDataJacket());
      setJackets(
        res.map((jacket, index) => {
          return {
            key: index,
            no: index + 1,
            id: jacket.id,
            name: jacket.data.name,
            kind: jacket.data.kind,
            stock: jacket.data.stock,
            price: jacket.data.price,
            promoPrice: jacket.data.promoPrice,
            shopee: jacket.data.shopee,
            tokopedia: jacket.data.tokopedia,
            lazada: jacket.data.lazada,
            image_url: jacket.data.image_url,
            desc: jacket.data.desc,
            size: jacket.data.size,
            published: jacket.data.publish,
            benefit: jacket.data.benefit,
          };
        }),
      );
    };
    getData();
  }, [dispatch]);

  const handleEdit = (e) => {
    const id = e.currentTarget.value;
    navigate(`/dashboard/jacket/edit/${id}`);
  };

  const handleDelete = (id) => {
    dispatch(deleteDataJacket(id));
    const newData = jackets.filter((trouser) => trouser.id !== id);
    setJackets(newData);
  };

    const dataSource = jackets;
    const columns = [
      {
        title: 'No',
        dataIndex: 'no',
        key: 'no',
        align: 'center',
        width: '2%',
      },
      {
        title: 'image',
        dataIndex: 'image_url',
        key: 'image_url',
        align: 'center',
        width: '15%',
        render: (res) => {
          return <img src={res} alt='gambar' width={150} height={150} />;
        },
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        width: '15%',
      },
      {
        title: 'Kinds',
        dataIndex: 'kind',
        key: 'kind',
        align: 'center',
        width: '12%',
      },
      {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
        align: 'center',
        width: '10%',
        render: (res) => {
          const price = parseInt(res);
          return <span>{`Rp. ${price.toLocaleString(`id-ID`)}`}</span>;
        },
      },
      {
        title: 'Promo Price',
        dataIndex: 'promoPrice',
        key: 'promoPrice',
        width: '10%',
        align: 'center',
        render: (res) => {
          const price = parseInt(res);
          return <span>{`Rp. ${price.toLocaleString(`id-ID`)}`}</span>;
        },
      },
      {
        title: 'Stock',
        dataIndex: 'stock',
        key: 'stock',
        align: 'center',
        width: '5%',
      },
      {
        title: 'Size',
        dataIndex: 'size',
        key: 'size',
        align: 'center',
        width: '12%',
        render: (result) => {
          let data = [];
          // eslint-disable-next-line array-callback-return
          Object.keys(result).map((key) => {
            data.push({
              size: key,
              res: result[key],
            });
          });
          const size = data
            .filter((res) => res.res === true)
            .map((res, index) => {
              return (
                <Badge
                  key={index}
                  status='success'
                  text={<span style={{ marginLeft: '-4px' }}>{res.size}</span>}
                  style={{ paddingRight: '10px' }}
                />
              );
            });
          return size;
        },
      },
      {
        title: 'Published',
        dataIndex: 'published',
        key: 'published',
        align: 'center',
        width: '5%',
        render: (result) => {
          return result === 'published' ? 'Yes' : 'No';
        },
      },
      {
        title: 'Action',
        key: 'action',
        align: 'center',
        width: '14%',
        render: (result) => {
          return (
            <>
              <Button
                onClick={handleEdit}
                value={result.id}
                icon={<EditFilled />}
                style={{ display: 'inline-block' }}
              />
              <Popconfirm
                onConfirm={() => handleDelete(result.id)}
                title={'Do You Want To Delete Data?'}
                onCancel={() => message.error('Data is Not Deleted')}
              >
                <Button
                  icon={<DeleteFilled />}
                  danger
                  type='primary'
                  style={{ display: 'inline-block', marginLeft: '12px' }}
                />
              </Popconfirm>
            </>
          );
        },
      },
    ];
    return (
      <Table dataSource={dataSource} columns={columns} loading={loading} />
    );
}

export default DashboardJacket